//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      env: JSON.stringify(process.env, null, 2)
    };
  }
};